import ThemeColorField from "./ThemeColorField";
import CooperativeThemePreview from "./CooperativeThemePreview";
import { DEFAULT_THEME } from "../../theme/companyTheme";

export default function ThemeBrandingEditor({
  primaryColor,
  secondaryColor,
  onPrimaryChange,
  onSecondaryChange,
  onResetDefaults,
  logoUrl,
  companyName,
}) {
  return (
    <div>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
        <p className="fw-semibold mb-0" style={{ color: "#383838" }}>
          Portal branding
        </p>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={onResetDefaults}
        >
          Reset to Default Theme
        </button>
      </div>

      <ThemeColorField
        label="Primary Color"
        name="primary_color"
        value={primaryColor}
        onChange={onPrimaryChange}
        defaultColor={DEFAULT_THEME.primary}
      />
      <ThemeColorField
        label="Secondary Color"
        name="secondary_color"
        value={secondaryColor}
        onChange={onSecondaryChange}
        defaultColor={DEFAULT_THEME.secondary}
      />

      <CooperativeThemePreview
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        logoUrl={logoUrl}
        companyName={companyName}
      />
    </div>
  );
}
